import React from "react";
import {
    CardContent,
    AccordionSummary,
    AccordionDetails,
    Chip,
    Box,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import {
    StyledCard,
    StyledTypography,
    StyledDivider,
    StyledAccordion,
} from "components/Screens/Company/CompanySummary";
import Markdown from "components/Common/Markdown/Markdown";
import { KeyDebate } from "../types";

interface Props {
    keyDebates: KeyDebate[];
}

const KeyDebatesSection: React.FC<Props> = ({ keyDebates }) => {
    if (!keyDebates || keyDebates.length === 0) {
        return null;
    }

    return (
        <StyledCard sx={{ height: "fit-content" }}>
            <CardContent>
                <StyledTypography
                    variant="h6"
                    color="primary"
                    fontWeight="bold"
                >
                    Key Debates
                </StyledTypography>
                <StyledDivider sx={{ my: 2 }} />
                {keyDebates.map((debate, index) => (
                    <StyledAccordion key={index} variant="outlined">
                        <AccordionSummary
                            expandIcon={
                                <FontAwesomeIcon icon={faChevronDown} />
                            }
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    width: "100%",
                                }}
                            >
                                {debate.debate_tag && (
                                    <Chip
                                        label={debate.debate_tag.name}
                                        size="small"
                                        sx={{
                                            fontWeight: "bold",
                                            borderRadius: "4px",
                                            color: debate.debate_tag.color,
                                        }}
                                    />
                                )}
                                <Markdown
                                    text={debate.debate_markdown}
                                    fontSize="16px"
                                />
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            {debate.comment_markdown && (
                                <Markdown
                                    text={debate.comment_markdown}
                                    fontSize="16px"
                                />
                            )}
                        </AccordionDetails>
                    </StyledAccordion>
                ))}
            </CardContent>
        </StyledCard>
    );
};

export default KeyDebatesSection;
